import {
  FETCH_APPLICATION_LIST_SUCCESS,
  FETCH_APPLICATION_LIST_FAILED,
  FETCH_APPLICATION_LIST_LOADING,
  FETCH_APPLICATION_DETAIL_SUCCESS,
  FETCH_APPLICATION_DETAIL_FAILED,
  FETCH_APPLICATION_DETAIL_LOADING,
  FETCH_APPLICATION_DETAIL_INFO_SUCCESS,
  FETCH_APPLICATION_DETAIL_INFO_FAILED,
  FETCH_APPLICATION_DETAIL_INFO_LOADING,
  FETCH_CHOOSE_LIST,
  FETCH_CATEGORYS,
  FETCH_CUSTOM_CATEGORYS,
  FETCH_DEFAULT_CONFIG,
  FETCH_APPLICATION_DEFAULT_SUCCESS,
  SET_APPLICATIONMODALVISIBLE,
} from "../actions/application";

import {
  SET_TIPMODAL_VISIBLE
} from '../actions/applicationBuild';

const defVal = {
  // 加载应用列表接口
  fetchApplicationListLoading: false,
  // applicationList: [{
  //   "id": 117,
  //   "userId": "05cf1cde42e84093aa9793a805b8790b",
  //   "appId": "93979a7cc7514d09ab5264c6c7fba81f",
  //   "appName": "萤石生态APP",
  //   "appLogo": "http://test14fdfs.ys7.com/group1/M00/00/05/rBThFl4cUVeAd-deAAAQqK2Bvyc941.png",
  //   "networkDeviceType": null,
  //   "privacyClause": "33dc5c145c72436083f77da00805c0ac",
  //   "serviceAgreement": "5f7e7e07af244ba9ab74700124a96318",
  //   "themeTone": "#46kugh",
  //   "noticePage": "http://test14fdfs.ys7.com/group1/M00/00/04/rBThJ13rEvSAHag6AAIiBWW0OyI64.jpeg",
  //   "noticeText": "",
  //   "versionInfo": "56b252c8e28649d0ac538c2b1c22aab4",
  //   "versionCode": "V1.0.0.1",
  //   "businessCopy": "",
  //   "logoutText": "4b3e4e75d27b4919aa9efeaf1214a29f",
  //   "bundleId": "TestFlight",
  //   "androidName": "androidEzviz",
  //   "androidPolicyInfo": "android政策",
  //   "iosPolicyInfo": "ios政策",
  //   "mobileProvision": "",
  //   "iosPolicyPassword": "",
  //   "extendInfo": "",
  //   "createTime": 1575686463000
  // },
  // {
  //   "id": 118,
  //   "userId": "05cf1cde42e84093aa9793a805b8790b",
  //   "appId": "93979a7cc7514d09ab5264c6c7fba81f",
  //   "appName": "萤石生态APP",
  //   "appLogo": "http://test14fdfs.ys7.com/group1/M00/00/05/rBThFl4cUVeAd-deAAAQqK2Bvyc941.png",
  //   "networkDeviceType": null,
  //   "privacyClause": "33dc5c145c72436083f77da00805c0ac",
  //   "serviceAgreement": "5f7e7e07af244ba9ab74700124a96318",
  //   "themeTone": "#46kugh",
  //   "noticePage": "http://test14fdfs.ys7.com/group1/M00/00/04/rBThJ13rEvSAHag6AAIiBWW0OyI64.jpeg",
  //   "noticeText": "",
  //   "versionInfo": "56b252c8e28649d0ac538c2b1c22aab4",
  //   "versionCode": "V1.0.0.1",
  //   "businessCopy": "",
  //   "logoutText": "4b3e4e75d27b4919aa9efeaf1214a29f",
  //   "bundleId": "TestFlight",
  //   "androidName": "androidEzviz",
  //   "androidPolicyInfo": "android政策",
  //   "iosPolicyInfo": "ios政策",
  //   "mobileProvision": "",
  //   "iosPolicyPassword": "",
  //   "extendInfo": "",
  //   "createTime": 1575686463000
  // },
  // {
  //   "id": 119,
  //   "userId": "05cf1cde42e84093aa9793a805b8790b",
  //   "appId": "93979a7cc7514d09ab5264c6c7fba81f",
  //   "appName": "萤石生态APP",
  //   "appLogo": "http://test14fdfs.ys7.com/group1/M00/00/05/rBThFl4cUVeAd-deAAAQqK2Bvyc941.png",
  //   "networkDeviceType": null,
  //   "privacyClause": "33dc5c145c72436083f77da00805c0ac",
  //   "serviceAgreement": "5f7e7e07af244ba9ab74700124a96318",
  //   "themeTone": "#46kugh",
  //   "noticePage": "http://test14fdfs.ys7.com/group1/M00/00/04/rBThJ13rEvSAHag6AAIiBWW0OyI64.jpeg",
  //   "noticeText": "",
  //   "versionInfo": "56b252c8e28649d0ac538c2b1c22aab4",
  //   "versionCode": "V1.0.0.1",
  //   "businessCopy": "",
  //   "logoutText": "4b3e4e75d27b4919aa9efeaf1214a29f",
  //   "bundleId": "TestFlight",
  //   "androidName": "androidEzviz",
  //   "androidPolicyInfo": "android政策",
  //   "iosPolicyInfo": "ios政策",
  //   "mobileProvision": "",
  //   "iosPolicyPassword": "",
  //   "extendInfo": "",
  //   "createTime": 1575686463000
  // },
  // ],
  // 应用列表
  applicationList: [],
  // 应用列表分页信息
  applicationListPage: { page: 0, size: 10, total: 0 },
  // 加载应用详情接口
  fetchApplicationDetailLoading: false,
  // 应用详情
  // applicationDetail: {
  //   "id": 119,
  //   "userId": "05cf1cde42e84093aa9793a805b8790b",
  //   "appId": "93979a7cc7514d09ab5264c6c7fba81f",
  //   "appName": "萤石生态APP",
  //   "appLogo": "http://test14fdfs.ys7.com/group1/M00/00/05/rBThFl4cUVeAd-deAAAQqK2Bvyc941.png",
  //   "networkDeviceType": null,
  //   "privacyClause": "33dc5c145c72436083f77da00805c0ac",
  //   "serviceAgreement": "5f7e7e07af244ba9ab74700124a96318",
  //   "themeTone": "#46kugh",
  //   "noticePage": "http://test14fdfs.ys7.com/group1/M00/00/04/rBThJ13rEvSAHag6AAIiBWW0OyI64.jpeg",
  //   "noticeText": "",
  //   "versionInfo": "56b252c8e28649d0ac538c2b1c22aab4",
  //   "versionCode": "V1.0.0.1",
  //   "businessCopy": "",
  //   "logoutText": "4b3e4e75d27b4919aa9efeaf1214a29f",
  //   "bundleId": "TestFlight",
  //   "androidName": "androidEzviz",
  //   "androidPolicyInfo": "android政策",
  //   "iosPolicyInfo": "ios政策",
  //   "mobileProvision": "",
  //   "iosPolicyPassword": "",
  //   "extendInfo": "",
  //   "createTime": 1575686463000
  // }
  // 应用详情
  applicationDetail: {},
  // 加载应用定制信息接口
  fetchApplicationDetailInfoLoading: false,
  // 应用定制信息
  applicationDetailInfo: {},
  // 默认应用配置信息主要用于模板下载
  applicationDefault: {},
  // 创建应用弹框是否显示
  applicationModalVisible: false,
  chooseList: [],
  categorys: [],
  customCategorys: [],
  defaultConfig: {},
  // 打包超限弹框展示
  tipModalVisible: false,
  tipType: 'day',
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_APPLICATION_LIST_SUCCESS:
      return Object.assign({}, state, {
        applicationList: action.applicationList,
        applicationListPage: action.applicationListPage,
        fetchApplicationListLoading: false,
      });
    case FETCH_APPLICATION_LIST_FAILED:
      return Object.assign({}, state, {
        fetchApplicationListLoading: false,
      });
    case FETCH_APPLICATION_LIST_LOADING:
      return Object.assign({}, state, {
        fetchApplicationListLoading: true,
      });
    case FETCH_APPLICATION_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        applicationDetail: action.applicationDetail,
        fetchApplicationDetailLoading: false,
      });
    case FETCH_APPLICATION_DETAIL_LOADING:
      return Object.assign({}, state, {
        fetchApplicationDetailLoading: true,
      });
    case FETCH_APPLICATION_DETAIL_FAILED:
      return Object.assign({}, state, {
        fetchApplicationDetailLoading: false,
      });
    case FETCH_APPLICATION_DETAIL_INFO_SUCCESS:
      return Object.assign({}, state, {
        applicationDetailInfo: action.applicationDetailInfo,
        fetchApplicationDetailInfoLoading: false,
      });
    case FETCH_APPLICATION_DETAIL_INFO_LOADING:
      return Object.assign({}, state, {
        fetchApplicationDetailInfoLoading: true,
      });
    case FETCH_APPLICATION_DETAIL_INFO_FAILED:
      return Object.assign({}, state, {
        fetchApplicationDetailInfoLoading: false,
      });
    case FETCH_CHOOSE_LIST:
      return Object.assign({}, state, {
        chooseList: action.chooseList
      })
    case FETCH_CATEGORYS:
      return Object.assign({}, state, {
        categorys: action.categorys
      })
    case FETCH_CUSTOM_CATEGORYS:
      return Object.assign({}, state, {
        customCategorys: action.customCategorys
      })
    case FETCH_DEFAULT_CONFIG:
      return Object.assign({}, state, {
        defaultConfig: action.defaultConfig
      })

    case FETCH_APPLICATION_DEFAULT_SUCCESS:
      return Object.assign({}, state, {
        applicationDefault: action.applicationDefault
      })

    case SET_APPLICATIONMODALVISIBLE:
      return Object.assign({}, state, {
        applicationModalVisible: action.applicationModalVisible
      })
    case SET_TIPMODAL_VISIBLE:
      return Object.assign({}, state, {
        tipModalVisible: action.tipModalVisible,
        tipType: action.tipType,
      })

    default:
      return state;
  }
};
